import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  static targets = ["modal", "step1", "step2", "step3", "video", "container"]
  static values = {
    id: String,
    autoShow: Boolean,
    autoAdvance: Boolean,
    oneTime: Boolean,
    openEventName: String,
    openEventProperties: String
  }

  connect() {
    this.eventTracker = new EventTrackerService();
    this.eventTracker.initialize();

    if (this.autoShowValue === undefined) {
      this.autoShowValue = true
    }

    if (this.autoShowValue && this.shouldShow()) {
      this.show()
    }

    this.containerTarget.addEventListener("scroll", () => {
      clearTimeout(this._scrollTimer);
      this._scrollTimer = setTimeout(() => this.restartVideos(), 150);
    });
  }

  _clearAutoAdvanceTimer() {
    if (this._autoAdvanceTimer) {
      clearTimeout(this._autoAdvanceTimer);
      this._autoAdvanceTimer = null;
    }
  }

  _startAutoAdvanceTimer() {
    this._clearAutoAdvanceTimer();

    // Respect user preference for reduced motion: do not auto-advance when enabled.
    if (typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    this._autoAdvanceTimer = setTimeout(() => {
      this.scrollToStep(this.step2Target);
    }, 5000);
  }

  disconnect() {
    this._clearAutoAdvanceTimer();
  }

  handleNextStep(e) {
    this._clearAutoAdvanceTimer();
    const nextStep = e.target.closest('.step').dataset.nextstep;
    const stepTarget = this.targets.find(nextStep);
    this.scrollToStep(stepTarget);
  }

  handlePreviousStep(e) {
    this._clearAutoAdvanceTimer();
    const previousStep = e.target.closest('.step').dataset.previousstep;
    const stepTarget = this.targets.find(previousStep);
    this.scrollToStep(stepTarget);
  }

  scrollToStep(step) {
    step.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
    this.restartVideos();
  }

  restartVideos(){
    Array.from(this.videoTargets).forEach(video => {
      video.currentTime = 0;
      video.play();
    });
  }

  show() {
    this.modalTarget.style.display = 'flex'
    document.dispatchEvent(new CustomEvent('modal:shown', { detail: { id: this.idValue } }))

    if (this.openEventNameValue) {
      this.eventTracker.trackEvent(this.openEventNameValue, this.openEventPropertiesValue, this.element);
    }

    if (this.autoAdvanceValue && this.shouldShow()) {
      this._startAutoAdvanceTimer();
    }
  }

  hide() {
    this.modalTarget.style.display = 'none'
    document.dispatchEvent(new CustomEvent('modal:hidden', { detail: { id: this.idValue } }))

    this._clearAutoAdvanceTimer();

    if (this.oneTimeValue) {
      this.setCookie()
    }
  }

  setCookieAndNavigate(event) {
    if (this.oneTimeValue) {
      this.setCookie()
    }
  }

  shouldShow() {
    return !this.oneTimeValue || !this.hasSeenModal()
  }

  get cookieName() {
    return `${this.idValue}_seen`
  }

  hasSeenModal() {
    return document.cookie.split(';').some(cookie =>
      cookie.trim().startsWith(`${this.cookieName}=true`)
    )
  }

  setCookie() {
    document.cookie = `${this.cookieName}=true; max-age=31536000; path=/`
  }
}